import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
// import common from '../../EqpInfoCommon.script.js'

/**
 * Recipe/Step Save Modal Component
 * Recipe/Step 정보를 저장하는 component
 */
export default {
  name: 'recipeSaveModal',
  /**
   * Modal 표시 여부
   * @param {Boolean} visible
   *
   * Modal 초기 data
   * @param {Object} initValue
   *
   * Save Method 실행 여부
   * @param {Boolean} saveReady
   *
   * Save 종료 시 실행 method
   * @param {Function} saveComplete
   *
   * Save 취소 시 실행 method
   * @param {Function} cancelSave
  */
  props: [
    'visible',
    'initValue',
    'saveReady',
    'saveComplete',
    'cancelSave'
  ],
  watch: {
    /**
     * initValue 변화 감지
     * 초기 data를 설정합니다.
     */
    initValue: {
      deep: true,
      handler () {
        if (this.initValue.saveType) {
          this.initData()
          this.initColumns()
        }
      }
    },
    /**
     * saveReady 변화 감지
     * @param {Boolean} value 저장 실행 여부
     * saveReady가 true일 때 saveData method를 실행합니다.
     */
    saveReady (value) {
      if (value) {
        this.saveDataRecipe()
      }
    }
  },
  beforeMount () {
    this.initData()
    this.initColumns()
  },
  methods: {
    /**
     * 초기 Data 설정
     */
    initData () {
      if (this.initValue.recipeList.length < 1) {
        return
      }

      if (this.initValue.saveType === 'Edit') {
        this.setInitData()
      } else if (this.initValue.saveType === 'Add') {
        this.rowDataRecipe = this.initValue.recipeList
      }
    },
    /**
     * Column Initialize
     */
    initColumns () {
      this.columnsRecipe = this.initValue.saveType === 'Edit' ? this.columnsRecipeEdit : this.columnsRecipeAdd

      this.columnsStep = [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, modifiable: false, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 90, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 90, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.START_SETTLING_TIME') + ' (s)', field: 'startSettlingTime', width: 150, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.END_SETTLING_TIME') + ' (s)', field: 'endSettlingTime', width: 150, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.ACTIVATION_TIME'), field: 'activationTime', width: 130, required: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, dataMap: 'useYnList', required: true, modifiable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'stepDesc', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, editable: false, type: 'dateTimeColumn', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false, hide: true }
      ] // Step Grid column 배열
    },
    /**
     * 초기 Data 설정 (Edit)
     * Edit 시 step 목록을 조회합니다.
     */
    async setInitData () {
      let payload = {
        fab: this.initValue.recipeList[0].fab,
        eqpId: this.initValue.recipeList[0].eqpId,
        moduleId: this.initValue.recipeList[0].moduleId,
        recipeId: this.initValue.recipeList[0].recipeId
      }
      let stepList = await API.BaseInfo.getEqpRecipeSteps(payload)

      // 초기값
      this.rowInitDataRecipe = this.initValue.recipeList
      this.rowInitDataStep = stepList.map(step => Object.assign({}, step))
      this.rowDataRecipe = [Object.assign({}, this.initValue.recipeList[0])] // await API.FdcEqpInfo.stepList(payload) 호출전에 대입해버리면 this.rowDataStep와 대입하는데 시간차가 발생하여 recipeGrid가 비어버리는 현상이 발생
      this.rowDataStep = [...stepList]
    },
    /**
     * Data 초기화
     */
    resetData () {
      this.rowDataRecipe = []
      this.rowDataStep = []
      this.rowInitDataRecipe = []
      this.rowInitDataStep = []
    },
    /**
     * Recipe 저장
     */
    async saveDataRecipe () {
      let self = this
      // let allRows = this.$refs.recipeGrid.grid.rows
      // const checkedRows = this.$refs.recipeGrid.getCheckedRows()
      this.$refs.recipeGrid.gridApi.stopEditing()
      this.$refs.stepGrid.gridApi.stopEditing()
      const allRows = this.$refs.recipeGrid.getAllRows()
      // let modifiedRows = []

      // if (allRows.length > 0) {
      //   for (let i = 0; i < allRows.length; i++) {
      //     if (allRows[i].dataItem._status) {
      //       const data = _.clone(allRows[i].dataItem)
      //       delete data['_status']
      //       data['recipeDesc'] = data['recipeDesc'] ? data['recipeDesc'] : ''
      //       data['recipeDesc'] = data['recipeDesc'].trim()
      //       modifiedRows.push(data)
      //     }
      //   }
      // }

      // if (checkedRows < 1) {
      //   this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
      //   return
      // }

      let saveRows = []
      let recipeData = []

      for (let i in allRows) {
        const data = allRows[i]
        recipeData.push(data)
      }

      // allRows = this.$refs.stepGrid.grid.rows
      const stepCheckedRows = this.$refs.stepGrid.getCheckedRows()
      const addedRows = this.$refs.stepGrid.getAddedRows()
      const updatedRows = this.$refs.stepGrid.getUpdatedRows()

      // modifiedRows = []

      // if (allRows.length > 0) {
      //   for (let i = 0; i < allRows.length; i++) {
      //     if (allRows[i].dataItem._status) {
      //       let data = _.clone(allRows[i].dataItem)
      //       delete data['_status']
      //       data['stepDesc'] = data['stepDesc'] ? data['stepDesc'] : ''
      //       data['stepDesc'] = data['stepDesc'].trim()
      //       modifiedRows.push(data)
      //     }
      //   }
      // }

      let stepData = []

      for (let i in stepCheckedRows) {
        const data = stepCheckedRows[i]
        data.recipeId = this.rowDataRecipe[0].recipeId
        const rowStatus = data.briqueGridCud
        if (rowStatus === 'C' || rowStatus === 'U') {
          saveRows.push(data)
        }
        stepData.push(data)
      }

      if (stepData.some(data => data.recipeId !== recipeData[0].recipeId)) {
        self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Recipe ID']))
        return
      }

      if (!self.saveEditValidation(recipeData[0]) || stepData.some(data => !self.saveEditStepValidation(data))) {
        this.cancelSave()
        return
      }

      let confirmMessage = ''
      if (!_.isEqual(saveRows.length, (addedRows.length + updatedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      // let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: confirmMessage,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))

              // Modal Close
              self.resetData()
              self.saveComplete()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          const data = { recipeData, stepData }
          if (recipeData.length > 0) {
            console.log({ data })
            API.BaseInfo.saveEqpRecipe(data).then(result => {
              saveLastProcess(result)
            })
          }
        },
        onCancel: function () {
          self.cancelSave()
        }
      })
    },
    async deleteDataStep () {
      let self = this
      // let allRows = this.$refs.stepManagerGrid.grid.rows
      // let checkedRows = common.getCheckedRows(allRows)
      const checkedRows = this.$refs.stepGrid.getCheckedRows()

      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Item']))
        return
      }

      let mustDeleteRows = []

      for (let i in checkedRows) {
        let isCreate = true
        if (!checkedRows[i].isNew) {
          isCreate = false
        }
        var data = checkedRows[i]
        if (!isCreate) {
          mustDeleteRows.push(data)
        }
      }

      let message = (mustDeleteRows.length) + ' ' + this.$t('fdc.COMMON.MESSAGE.CONFIRM_MULTI_DELETE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function deleteLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_DELETE'))
              self.$refs.stepGrid.onClickRemoveRow()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_DELETE'))
            }
          }

          if (mustDeleteRows.length > 0) {
            API.BaseInfo.putEqpRecipeStep(mustDeleteRows).then(result => {
              deleteLastProcess(result)
            })
          }
        },
        onCancel: function () {}
      })
    },
    /**
     * Recipe Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveEditValidation (row) {
      if (!row.eqpId || row.eqpId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
        return false
      } else if (!row.moduleId || row.moduleId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
        return false
      } else if (!row.recipeId || row.recipeId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Recipe']))
        return false
      } else if (row.maxProcTime === '' || row.maxProcTime === undefined) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Max Proc Time']))
        return false
      } else if (!row.useYn || row.useYn.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Usable']))
        return false
      }
      let isNotUseYn = true
      for (let j in this.useYnList) {
        if (row.useYn === this.useYnList[j].useYn) {
          isNotUseYn = false
        }
      }
      if (isNotUseYn) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Usable']))
        return false
      }

      return true
    },
    /**
     * Step Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveEditStepValidation (row) {
      if (!row.eqpId || row.eqpId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
        return false
      } else if (!row.moduleId || row.moduleId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
        return false
      } else if (!row.recipeId || row.recipeId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Recipe']))
        return false
      } else if (!row.stepId || row.stepId.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Step']))
        return false
      } else if (!row.useYn || row.useYn.trim() === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Usable']))
        return false
      }
      let isNotUseYn = true
      for (let j in this.useYnList) {
        if (row.useYn === this.useYnList[j].useYn) {
          isNotUseYn = false
        }
      }
      if (isNotUseYn) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Usable']))
        return false
      }

      return true
    },
    /**
     * Recipe Grid 재설정(refresh)
     */
    refreshGridRecipe () {
      if (this.initValue.saveType === 'Add') {
        this.rowDataRecipe = [{
          fab: this.initValue.recipeList[0].fab,
          eqpId: this.initValue.recipeList[0].eqpId,
          moduleId: this.initValue.recipeList[0].moduleId,
          stepCount: this.initValue.recipeList[0].stepCount,
          maxProcTime: this.initValue.recipeList[0].maxProcTime,
          useYn: this.initValue.recipeList[0].useYn
        }]
      } else if (this.initValue.saveType === 'Edit') {
        this.rowDataRecipe = this.rowInitDataRecipe.map(rowData => Object.assign({}, rowData))
      }
    },
    /**
     * Step Grid 재설정(refresh)
     */
    refreshGridStep () {
      if (this.initValue.saveType === 'Add') {
        this.rowDataStep = []
      } else if (this.initValue.saveType === 'Edit') {
        this.rowDataStep = this.rowInitDataStep.map(rowData => Object.assign({}, rowData))

        // recipe info의 stepCount를 초기화
        // const currentStepCount = this.rowDataStep.length
        // let recipeInfo = this.$refs.recipeGrid.grid.rows[0].dataItem
        // recipeInfo.stepCount = currentStepCount
        // this.rowDataRecipe = [recipeInfo]
      }
    },
    /**
     * Step Grid row 추가
     */
    newRowAddStep () {
      // const newStepCount = this.$refs.stepGrid.grid.rows.length + 1

      let obj = {
        fab: this.rowDataRecipe[0].fab,
        eqpId: this.rowDataRecipe[0].eqpId,
        moduleId: this.rowDataRecipe[0].moduleId,
        recipeId: this.rowDataRecipe[0].recipeId,
        startSettlingTime: 0,
        endSettlingTime: -1,
        activationTime: -1,
        useYn: 'Y',
        isNew: true,
        gridId: _.uniqueId('step_')
      }

      // let status = {
      //   checked: true,
      //   modified: false,
      //   added: true
      // }
      // this.$refs.stepGrid.addRows(arr, status)
      this.$refs.stepGrid.addRowOne(obj)
      this.selectAddedRow(obj)

      // service에서 처리해 줌으로 주석처리
      // recipe info의 stepCount를 갱신
      // recipeInfo.stepCount = newStepCount

      // FIXME: 불필요한 로직으로 주석처리 (확인 필요)
      // let recipeInfo = Object.assign({}, this.$refs.recipeGrid.getAllRows()[0])
      // this.rowDataRecipe = [recipeInfo]
    },
    /**
     * after add
     */
    selectAddedRow (data) {
      const model = this.$refs.stepGrid.gridApi.getModel()
      // console.log('selectAddedRow', model, data)
      if (model) {
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const rowNode = model.getRow(i)
          if (rowNode.data.gridId === data.gridId) {
            rowNode.setSelected(true)
            break
          }
        }
      }
    },
    /**
     * Step Grid row 삭제
     */
    _deleteDataStep () {
      // let allRows = this.$refs.stepGrid.grid.rows
      // // let newDataStepEdit = new Array(allRows.length)
      // let deleteIndexList = []

      // // add 된 row는 delete 아닌 row는 useYn 'N'으로 변경
      // if (allRows.length > 0) {
      //   for (let i = 0; i < allRows.length; i++) {
      //     if (allRows[i].dataItem._status) {
      //       if (!allRows[i].dataItem._status.added) {
      //         // newDataStepEdit[i] = this.rowDataStep[i]
      //         if (allRows[i].dataItem._status.checked) {
      //           // newDataStepEdit[i].useYn =  'N'
      //           allRows[i].dataItem.useYn = 'N'
      //         }
      //       } else {
      //         deleteIndexList.push(i)
      //       }
      //     }
      //   }
      // }

      // if (deleteIndexList.length > 0) {
      //   for (var i = deleteIndexList.length - 1; i >= 0; i--) {
      //     this.$refs.stepGrid.grid.collectionView.removeAt(deleteIndexList[i])
      //   }
      // }

      // this.$refs.stepGrid.grid.collectionView.refresh()
      // // this.rowDataStep = newDataStepEdit

      this.$refs.stepGrid.onClickRemoveRow()
    },
    /**
     * Step Grid add된 row에 대한 validation 체크
     * @param {Object} params row data
     * @returns {Boolean} validation 성공 여부
     */
    // newRowsKeyValidation (params) {
    //   let allRows = []
    //   if (params.stepId) {
    //     allRows = this.$refs.stepGrid.grid.rows
    //   } else {
    //     allRows = this.$refs.recipeGrid.grid.rows
    //   }
    //   let addedRows = common.getAddedRows(allRows)
    //   let result = true
    //   let sameDataCnt = 0
    //   for (var i in addedRows) {
    //     if (params.stepId) {
    //       if (addedRows[i].fab === params.fab &&
    //         addedRows[i].eqpId === params.eqpId &&
    //         addedRows[i].moduleId === params.moduleId &&
    //         addedRows[i].recipeId === params.recipeId &&
    //         addedRows[i].stepId === params.stepId &&
    //         addedRows[i].stepId) {
    //         // result = false
    //         // break
    //         sameDataCnt++
    //       }
    //     } else {
    //       if (addedRows[i].fab === params.fab &&
    //         addedRows[i].eqpId === params.eqpId &&
    //         addedRows[i].moduleId === params.moduleId &&
    //         addedRows[i].recipeId === params.recipeId &&
    //         addedRows[i].recipeId) {
    //         // result = false
    //         // break
    //         sameDataCnt++
    //       }
    //     }
    //   }
    //   if (sameDataCnt > 1) {
    //     result = false
    //   }
    //   return result
    // },
    /**
     * Step Grid에 check된 check된 row count 확인
     * @returns {Boolean} check된 row가 있는지 여부
     */
    hasCheckedRowsStep () {
      if (!this.$refs.stepGrid) {
        return 0
      }
      return this.$refs.stepGrid.checkedRowCount > 0
    }
  },
  data () {
    return {
      columnsRecipe: [], // Recipe Grid column 배열 (Edit)
      columnsRecipeEdit: [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100, required: true, modifiable: false },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP_COUNT'), field: 'stepCount', width: 100, editable: false, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MAX_PROCESS_TIME'), field: 'maxProcTime', width: 150, required: true, modifiable: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, dataMap: 'useYnList', required: true, modifiable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'recipeDesc', width: 150, modifiable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, editable: false, type: 'dateTimeColumn', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false, hide: true }
      ], // Recipe Grid column 배열 (Edit)
      columnsRecipeAdd: [
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, required: true, modifiable: false, visible: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, required: true, modifiable: false, visible: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 100, required: true, modifiable: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.STEP_COUNT'), field: 'stepCount', width: 100, editable: false, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MAX_PROCESS_TIME'), field: 'maxProcTime', width: 150, required: true, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 90, dataMap: 'useYnList', required: true, modifiable: true, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.DESCRIPTION'), field: 'recipeDesc', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 160, editable: false, type: 'dateTimeColumn', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110, editable: false, hide: true }
      ], // Recipe Grid column 배열 (Add)
      // columnsRecipe2: [], // Recipe Grid column 배열 (Add)
      columnsStep: [], // Step Grid column 배열
      defaultColDef: {
        minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true,
        editable: true
      }, // BRIQUE Grid column default setting
      useYnList: [
        { useYn: 'Y' },
        { useYn: 'N' }
      ], // Use YN dataMap 배열
      rowDataRecipe: [], // Recipe Grid row data 배열
      rowDataStep: [], // Step Grid row data 배열
      rowInitDataRecipe: [], // Recipe Grid row data 배열 (초기값 - 수정 전)
      rowInitDataStep: [] // Step Grid row data 배열 (초기값 - 수정 전)
    }
  }
}
